import React from 'react';
import { Card, Badge } from '@/components/ui';
import { useNavigate } from 'react-router-dom';
import { FolderOpen, FileCheck, History, LayoutTemplate, Archive, Users, ArrowRight } from 'lucide-react';
import { cn } from '@/utils/cn';

export function DocumentsModulesGrid() {
  const navigate = useNavigate();

  const MODULES = [
    {
      id: 'list',
      title: 'Kho Tài Liệu',
      description: 'Quản lý tập trung bản vẽ, hợp đồng, hồ sơ dự án và tài liệu chuyên môn.',
      icon: <FolderOpen className="w-6 h-6" />,
      color: 'blue',
      path: '/documents/list',
      stats: '1,245 Tài liệu',
      gradient: 'from-blue-500 to-cyan-500',
      bgLight: 'bg-blue-50',
      textDark: 'text-blue-700'
    },
    {
      id: 'approvals',
      title: 'Quy trình Phê duyệt',
      description: 'Trình ký điện tử, xét duyệt hồ sơ thanh toán, bản vẽ thiết kế (Ký số).',
      icon: <FileCheck className="w-6 h-6" />,
      color: 'emerald',
      path: '/documents/approvals',
      stats: '12 Chờ ký',
      gradient: 'from-emerald-400 to-teal-500',
      bgLight: 'bg-emerald-50',
      textDark: 'text-emerald-700'
    },
    {
      id: 'versions',
      title: 'Quản lý Phiên bản',
      description: 'Theo dõi lịch sử sửa đổi (Version Control), khôi phục bản ghi cũ dễ dàng.',
      icon: <History className="w-6 h-6" />,
      color: 'amber',
      path: '/documents/versions',
      stats: 'Version Control',
      gradient: 'from-amber-400 to-orange-500',
      bgLight: 'bg-amber-50',
      textDark: 'text-amber-700'
    },
    {
      id: 'templates',
      title: 'Biểu mẫu & Template',
      description: 'Kho chứa các form chuẩn hóa ISO, biểu mẫu hợp đồng, biên bản nghiệm thu.',
      icon: <LayoutTemplate className="w-6 h-6" />,
      color: 'purple',
      path: '/documents/templates',
      stats: '45 Biểu mẫu',
      gradient: 'from-purple-500 to-pink-500',
      bgLight: 'bg-purple-50',
      textDark: 'text-purple-700'
    },
    {
      id: 'archive',
      title: 'Lưu trữ Cứng',
      description: 'Số hóa vị trí hồ sơ vật lý (Tủ, Kệ), quản lý vòng đời tài liệu kế toán.',
      icon: <Archive className="w-6 h-6" />,
      color: 'slate',
      path: '/documents/archive',
      stats: 'Tủ hồ sơ',
      gradient: 'from-slate-500 to-gray-600',
      bgLight: 'bg-slate-100',
      textDark: 'text-slate-700'
    },
    {
      id: 'sharing',
      title: 'Phân quyền Chia sẻ',
      description: 'Kiểm soát truy cập, mã hóa tài liệu mật và chia sẻ an toàn ra bên ngoài.',
      icon: <Users className="w-6 h-6" />,
      color: 'indigo',
      path: '/documents/sharing',
      stats: 'Bảo mật',
      gradient: 'from-indigo-500 to-violet-500',
      bgLight: 'bg-indigo-50',
      textDark: 'text-indigo-700'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 h-full">
      {MODULES.map((mod) => (
        <Card
          key={mod.id}
          onClick={() => navigate(mod.path)}
          className="group relative overflow-hidden bg-white border-2 border-slate-100 hover:border-blue-200 shadow-sm hover:shadow-xl rounded-3xl p-6 cursor-pointer transition-all duration-300 hover:-translate-y-1 h-full flex flex-col"
        >
          <div className={cn("absolute top-0 right-0 w-32 h-32 bg-gradient-to-br opacity-5 rounded-bl-full transition-transform duration-500 group-hover:scale-110", mod.gradient)} />

          <div className="flex items-start justify-between mb-4">
            <div className={cn("w-14 h-14 rounded-2xl flex items-center justify-center shadow-inner transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3", mod.bgLight, mod.textDark)}>
              {mod.icon}
            </div>
            <Badge variant="custom" className={cn("bg-slate-50 text-slate-600 border border-slate-100 font-bold px-2.5 py-1 text-[10px]")}>
              {mod.stats}
            </Badge>
          </div>

          <h4 className="text-lg font-black text-slate-800 mb-2 group-hover:text-blue-700 transition-colors">{mod.title}</h4>
          <p className="text-xs text-slate-500 leading-relaxed mb-6 line-clamp-2 min-h-[36px] flex-grow">
            {mod.description}
          </p>

          <div className="flex items-center text-sm font-bold text-blue-600 opacity-0 group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 transition-all duration-300 mt-auto">
            Truy cập ngay <ArrowRight className="w-4 h-4 ml-1.5" />
          </div>
        </Card>
      ))}
    </div>
  );
}
